module.exports = __webpack_public_path__ + "img/1.e41f5f52.png";